var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 8.2L38.9 7H25.1L24.4 8.2C23.5 9.6 23 11.3 23 13V52H41V13C41 11.3 40.5 9.6 39.6 8.2Z",
    fill: "#C0D1E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3 2.5C35.5 1.1 34.2 0.2 32.6 0H31.3C29.8 0.2 28.4 1.1 27.6 2.5L25.1 7H39L36.3 2.5Z",
    fill: "#56697A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36V53H52C52 50.8 51.9 48.6 51.7 46.4C51.3 43.9 48.9 42.4 46.7 40.6C44 38.2 41 36 41 36Z",
    fill: "#788FA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53H52V55H41V53Z",
    fill: "#4F5560"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 59H41C40.4 59 40 58.6 40 58C40 57.4 40.4 57 41 57H53C53.6 57 54 57.4 54 58C54 58.6 53.6 59 53 59Z",
    fill: "#F8C77E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 64H40.5C39.7 64 39 63.3 39 62.5C39 61.7 39.7 61 40.5 61H53.5C54.3 61 55 61.7 55 62.5C55 63.3 54.3 64 53.5 64Z",
    fill: "#F8C77E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 48V53H23V31L12.2 39.4C9.6 41.5 8 44.7 8 48Z",
    fill: "#4F5560"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 48V53H41V31L51.8 39.4C54.4 41.5 56 44.7 56 48Z",
    fill: "#4F5560"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53H23V36L14.7 42.5C13 43.8 12 45.9 12 48V53Z",
    fill: "#788FA5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52 53H41V36L49.3 42.5C51 43.8 52 45.9 52 48V53Z",
    fill: "#788FA5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53H23V55H12V53Z",
    fill: "#4F5560"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 57H23C23.6 57 24 57.4 24 58C24 58.6 23.6 59 23 59H11C10.4 59 10 58.6 10 58C10 57.4 10.4 57 11 57Z",
    fill: "#F8C77E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 61H23.5C24.3 61 25 61.7 25 62.5C25 63.3 24.3 64 23.5 64H10.5C9.7 64 9 63.3 9 62.5C9 61.7 9.7 61 10.5 61Z",
    fill: "#F8C77E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14C29.2 14 27 16.2 27 19C27 21.8 29.2 24 32 24C34.8 24 37 21.8 37 19C37 16.2 34.8 14 32 14Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22C33.6569 22 35 20.6569 35 19C35 17.3431 33.6569 16 32 16C30.3431 16 29 17.3431 29 19C29 20.6569 30.3431 22 32 22Z",
    fill: "#38434F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7a5c9ff051fdd8750249ed90af89954f.svg";
export { ForwardRef as ReactComponent };